// extracted by mini-css-extract-plugin
export default {"DownloadDialog":"DownloadDialog_DownloadDialog__HmS8T"};